export default "__VITE_ASSET__BvYSSxac__"